import { render, staticRenderFns } from "./ImageWithDetailToTop.vue?vue&type=template&id=23f391e8&scoped=true&"
import script from "./ImageWithDetailToTop.vue?vue&type=script&lang=js&"
export * from "./ImageWithDetailToTop.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithDetailToTop.vue?vue&type=style&index=0&id=23f391e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f391e8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
